"use client";
import React, { useEffect, useState } from "react";
import AreaGraph from "./OverviewGraph";
import CompanySnapshot from "./companySnapshot/CompanySnapshot";
import Financials from "./financials/Financials";
import Technical from "./Technical";
import Insights from "./Insights/Insights";
import Ltv from "./LTV/Ltv";
import Fundamentals from "./fundamentals/Fundamentals";
import StockPriceChart from "./OverviewGraph";

const StocksRight = ({ selectedStock }) => {
  const [activeButton, setActiveButton] = useState("overview");
  const [stockData, setStockData] = useState(null);
  const [selection, setSelection] = useState("one_year");

  const res = {
    data: {
      "HDFC Bank Ltd": [
        { x: new Date("2023-07-01T00:00:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:02:00").getTime(), y: 1400000 },
        { x: new Date("2023-07-01T00:04:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:06:00").getTime(), y: 1300000 },
        { x: new Date("2023-07-01T00:08:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:09:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:10:00").getTime(), y: 2000000 },
        { x: new Date("2023-07-01T00:12:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:14:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:16:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:45:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T01:30:00").getTime(), y: 1700000 },
        { x: new Date("2023-07-01T02:15:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T03:00:00").getTime(), y: 1900000 },
        { x: new Date("2023-07-01T03:45:00").getTime(), y: 2000000 },
      ],
      "JM Large Cap Fund (Direct) - Growtj": [
        { x: new Date("2023-07-01T00:00:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:02:00").getTime(), y: 1400000 },
        { x: new Date("2023-07-01T00:04:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:06:00").getTime(), y: 1300000 },
        { x: new Date("2023-07-01T00:08:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:09:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:10:00").getTime(), y: 2000000 },
        { x: new Date("2023-07-01T00:12:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:14:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:16:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:45:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T01:30:00").getTime(), y: 1700000 },
        { x: new Date("2023-07-01T02:15:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T03:00:00").getTime(), y: 1900000 },
        { x: new Date("2023-07-01T03:45:00").getTime(), y: 2000000 },
      ],
      "ITC Ltd": [
        { x: new Date("2023-07-01T00:00:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:02:00").getTime(), y: 1400000 },
        { x: new Date("2023-07-01T00:04:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:06:00").getTime(), y: 1300000 },
        { x: new Date("2023-07-01T00:08:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:09:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:10:00").getTime(), y: 2000000 },
        { x: new Date("2023-07-01T00:12:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:14:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:16:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:45:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T01:30:00").getTime(), y: 1700000 },
        { x: new Date("2023-07-01T02:15:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T03:00:00").getTime(), y: 1900000 },
        { x: new Date("2023-07-01T03:45:00").getTime(), y: 2000000 },
      ],
      "Invesco India LargeEcap Fund Direct Plan Growth": [
        { x: new Date("2023-07-01T00:00:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:02:00").getTime(), y: 1400000 },
        { x: new Date("2023-07-01T00:04:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:06:00").getTime(), y: 1300000 },
        { x: new Date("2023-07-01T00:08:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:09:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:10:00").getTime(), y: 2000000 },
        { x: new Date("2023-07-01T00:12:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:14:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:16:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:45:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T01:30:00").getTime(), y: 1700000 },
        { x: new Date("2023-07-01T02:15:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T03:00:00").getTime(), y: 1900000 },
        { x: new Date("2023-07-01T03:45:00").getTime(), y: 2000000 },
      ],
      "ITC Ltd": [
        { x: new Date("2023-07-01T00:00:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:02:00").getTime(), y: 1400000 },
        { x: new Date("2023-07-01T00:04:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:06:00").getTime(), y: 1300000 },
        { x: new Date("2023-07-01T00:08:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:09:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:10:00").getTime(), y: 2000000 },
        { x: new Date("2023-07-01T00:12:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:14:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:16:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:45:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T01:30:00").getTime(), y: 1700000 },
        { x: new Date("2023-07-01T02:15:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T03:00:00").getTime(), y: 1900000 },
        { x: new Date("2023-07-01T03:45:00").getTime(), y: 2000000 },
      ],
      "Nippon India Small Cap Fund - Growth Plan Growth Option": [
        { x: new Date("2023-07-01T00:00:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:02:00").getTime(), y: 1400000 },
        { x: new Date("2023-07-01T00:04:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:06:00").getTime(), y: 1300000 },
        { x: new Date("2023-07-01T00:08:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:09:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:10:00").getTime(), y: 2000000 },
        { x: new Date("2023-07-01T00:12:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:14:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:16:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:45:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T01:30:00").getTime(), y: 1700000 },
        { x: new Date("2023-07-01T02:15:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T03:00:00").getTime(), y: 1900000 },
        { x: new Date("2023-07-01T03:45:00").getTime(), y: 2000000 },
      ],
      "Invesco India Largecap Fund Direct Plan Growth": [
        { x: new Date("2023-07-01T00:00:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:02:00").getTime(), y: 1400000 },
        { x: new Date("2023-07-01T00:04:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:06:00").getTime(), y: 1300000 },
        { x: new Date("2023-07-01T00:08:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:09:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:10:00").getTime(), y: 2000000 },
        { x: new Date("2023-07-01T00:12:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:14:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:16:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:45:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T01:30:00").getTime(), y: 1700000 },
        { x: new Date("2023-07-01T02:15:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T03:00:00").getTime(), y: 1900000 },
        { x: new Date("2023-07-01T03:45:00").getTime(), y: 2000000 },
      ],
      "HDFC Bank": [
        { x: new Date("2023-07-01T00:00:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:02:00").getTime(), y: 1400000 },
        { x: new Date("2023-07-01T00:04:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:06:00").getTime(), y: 1300000 },
        { x: new Date("2023-07-01T00:08:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:09:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:10:00").getTime(), y: 2000000 },
        { x: new Date("2023-07-01T00:12:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:14:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:16:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:45:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T01:30:00").getTime(), y: 1700000 },
        { x: new Date("2023-07-01T02:15:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T03:00:00").getTime(), y: 1900000 },
        { x: new Date("2023-07-01T03:45:00").getTime(), y: 2000000 },
      ],
      "HDFC-Bank Ltd": [
        { x: new Date("2023-07-01T00:00:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:02:00").getTime(), y: 1400000 },
        { x: new Date("2023-07-01T00:04:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:06:00").getTime(), y: 1300000 },
        { x: new Date("2023-07-01T00:08:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:09:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:10:00").getTime(), y: 2000000 },
        { x: new Date("2023-07-01T00:12:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:14:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:16:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:45:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T01:30:00").getTime(), y: 1700000 },
        { x: new Date("2023-07-01T02:15:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T03:00:00").getTime(), y: 1900000 },
        { x: new Date("2023-07-01T03:45:00").getTime(), y: 2000000 },
      ],
      "HDFC Bank3 Ltd": [
        { x: new Date("2023-07-01T00:00:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:02:00").getTime(), y: 1400000 },
        { x: new Date("2023-07-01T00:04:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:06:00").getTime(), y: 1300000 },
        { x: new Date("2023-07-01T00:08:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:09:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:10:00").getTime(), y: 2000000 },
        { x: new Date("2023-07-01T00:12:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T00:14:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T00:16:00").getTime(), y: 1500000 },
        { x: new Date("2023-07-01T00:45:00").getTime(), y: 1600000 },
        { x: new Date("2023-07-01T01:30:00").getTime(), y: 1700000 },
        { x: new Date("2023-07-01T02:15:00").getTime(), y: 1800000 },
        { x: new Date("2023-07-01T03:00:00").getTime(), y: 1900000 },
        { x: new Date("2023-07-01T03:45:00").getTime(), y: 2000000 },
      ],
    },
  };

  useEffect(() => {
    if (selectedStock) {
      // console.log(selectedStock);
      const data = res.data[selectedStock.stockName] || [];
      // console.log(res.data[selectedStock.stockName]);
      setStockData(data);
    }
  }, [selectedStock]);

  return (
    <div className="h-[100vh] overflow-x-auto overflow-y-auto no-scrollbar">
      <div className="flex flex-row gap-[10px] h-[42px]  border-b border-solid border-[#d9d9d9] ">
        <button
          className={`px-3 py-4 text-sm font-normal ${
            activeButton === "overview"
              ? "border-b-4 border-solid border-[#00394d]  text-sm text-[#00394d] font-semibold"
              : ""
          }`}
          onClick={() => setActiveButton("overview")}
        >
          Overview
        </button>
        <button
          className={`px-3 py-4 text-sm font-normal ${
            activeButton === "Company Snapshot"
              ? "border-b-4 border-solid border-[#00394d]  text-sm text-[#00394d] font-semibold"
              : ""
          }`}
          onClick={() => setActiveButton("Company Snapshot")}
        >
          Company Snapshot
        </button>
        <button
          className={`px-3 py-4 text-sm font-normal ${
            activeButton === "Financials"
              ? "border-b-4 border-solid border-[#00394d]  text-sm text-[#00394d] font-semibold"
              : ""
          }`}
          onClick={() => setActiveButton("Financials")}
        >
          Financials
        </button>
        <button
          className={`px-3 py-4 text-sm font-normal ${
            activeButton === "Fundamentals"
              ? "border-b-4 border-solid border-[#00394d]  text-sm text-[#00394d] font-semibold"
              : ""
          }`}
          onClick={() => setActiveButton("Fundamentals")}
        >
          Fundamentals
        </button>
        <button
          className={`px-3 py-4 text-sm font-normal ${
            activeButton === "Technicals"
              ? "border-b-4 border-solid border-[#00394d]  text-sm text-[#00394d] font-semibold"
              : ""
          }`}
          onClick={() => setActiveButton("Technicals")}
        >
          Technicals
        </button>
        <button
          className={`px-3 py-4 text-sm font-normal ${
            activeButton === "Insights"
              ? "border-b-4 border-solid border-[#00394d]  text-sm text-[#00394d] font-semibold"
              : ""
          }`}
          onClick={() => setActiveButton("Insights")}
        >
          Insights
        </button>{" "}
        <button
          className={`px-3 py-4 text-sm font-normal ${
            activeButton === "LTV"
              ? "border-b-4 border-solid border-[#00394d]  text-sm text-[#00394d] font-semibold"
              : ""
          }`}
          onClick={() => setActiveButton("LTV")}
        >
          LTV
        </button>
      </div>

      {activeButton === "overview" ? (
        <>
          <StockPriceChart data={stockData} />
          <CompanySnapshot />
          <Financials />
          <Fundamentals />
          <Technical />
          <Insights />
          <Ltv />
        </>
      ) : activeButton === "Company Snapshot" ? (
        <>
          <CompanySnapshot />
        </>
      ) : activeButton === "Financials" ? (
        <>
          <Financials />
        </>
      ) : activeButton === "Fundamentals" ? (
        <Fundamentals />
      ) : activeButton === "Technicals" ? (
        <Technical />
      ) : activeButton === "Insights" ? (
        <Insights />
      ) : activeButton === "LTV" ? (
        <Ltv />
      ) : null}
    </div>
  );
};

export default StocksRight;
